import script from "./CommonConfig.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommonConfig.vue?vue&type=script&lang=ts&setup=true"

import "./CommonConfig.vue?vue&type=style&index=0&id=166240bb&lang=scss&scoped=true"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-166240bb"]])

export default __exports__